<div class="flex-col cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-3x">
    <div class="flex-row start-center layoutGap-8">
        <h3 class="flex mat-headline-6">Address Regions</h3>
        <button
            mat-raised-button
            (click)="newItemClicked()"
            [disabled]="!canEdit()"
            color="primary"
        >
            New Address Region
        </button>
        <button
            mat-raised-button
            (cbClick)="saveOrder()"
            [throttleTime]="2000"
            [disabled]="!sortOrderChanged || !canEdit()"
            color="primary"
        >
            Save Region Order
        </button>
    </div>
    <cb-table
        class="cb-margin-top"
        label="Address Regions"
        [stringColumns]="displayedColumns"
        [loaded]="searchResultsLoaded"
        [minWidth]="1000"
        [maxHeightOffset]="186"
    >
        <tbody
            cbTableBody
            cdkDropList
            [cdkDropListData]="searchResults"
            (cdkDropListDropped)="drop($event)"
        >
            @for (ele of searchResults; track ele) {
                <tr cdkDrag cdkDragPreviewClass="cb-table-drag-preview">
                    <td>{{ ele.name }}</td>
                    <cb-td-checkbox [value]="ele.isActive"></cb-td-checkbox>
                    <td cbTableShrinkCol cbTableStickyCol="end">
                        <button
                            mat-icon-button
                            (click)="editItemClickedForDto(ele)"
                            [disabled]="!canEdit()"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
</div>
